import { defineMessages } from 'react-intl-next';

export const addFieldMenuMessages = defineMessages({
  searchPlaceholder: {
    id: 'field-type.add-field-menu.search-placeholder',
    defaultMessage: 'Search fields',
    description: 'Search input placeholder for filtering options in the add field menu.'
  },
  aiFieldsSection: {
    id: 'field-type.add-field-menu.ai-fields-section',
    defaultMessage: 'AI fields',
    description: 'Section title for AI field type options in the add field menu.'
  },
  basicFieldTypesSection: {
    id: 'field-type.add-field-menu.basic-field-types-section',
    defaultMessage: 'Basic fields',
    description: 'Section title for basic field type options in the add field menu.'
  },
  aiSummary: {
    id: 'field-type.add-field-menu.ai-summary',
    defaultMessage: 'Summary',
    description: 'Menu item label for creating an AI summary field.'
  },
  advancedFieldTypesSection: {
    id: 'field-type.add-field-menu.advanced-field-types-section',
    defaultMessage: 'Advanced fields',
    description: 'Section title for advanced field type options in the add field menu.'
  },
  confluenceSection: {
    id: 'field-type.add-field-menu.confluence-section',
    defaultMessage: 'Confluence',
    description: 'Collapsed section label for Confluence field type options.'
  },
  confluenceLink: {
    id: 'field-type.add-field-menu.confluence-link',
    defaultMessage: 'Link',
    description: 'Short label for the Confluence link field type option.'
  },
  confluenceLinkM2: {
    id: 'field-type.add-field-menu.confluence-link-m2',
    defaultMessage: 'Confluence link',
    description: 'Short label for the Confluence link field type option in M2.'
  },
  confluenceStatus: {
    id: 'field-type.add-field-menu.confluence-status',
    defaultMessage: 'Status',
    description: 'Short label for the Confluence status field type option.'
  },
  confluenceLabel: {
    id: 'field-type.add-field-menu.confluence-label',
    defaultMessage: 'Label',
    description: 'Short label for the Confluence label field type option.'
  },
  confluenceMoreDetails: {
    id: 'field-type.add-field-menu.confluence-more-details',
    defaultMessage: 'More details',
    description: 'Short label for the Confluence more details field type option.'
  },
  confluenceDescription: {
    id: 'field-type.add-field-menu.confluence-description',
    defaultMessage: 'Description',
    description: 'Short label for the Confluence description field type option.'
  },
  confluenceEntryBackLink: {
    id: 'field-type.add-field-menu.confluence-entry-back-link',
    defaultMessage: 'Entry back link',
    description: 'Short label for the Confluence entry back link field type option.'
  },
  entryDetail: {
    id: 'field-type.add-field-menu.entry-detail',
    defaultMessage: 'Entry detail',
    description: 'Short label for the entry detail field type option.'
  },
  jiraLink: {
    id: 'field-type.add-field-menu.jira-link',
    defaultMessage: 'Jira link',
    description: 'Short label for the Jira link field type option.'
  },
  jiraDetail: {
    id: 'field-type.add-field-menu.jira-detail',
    defaultMessage: 'Jira detail',
    description: 'Short label for the Jira detail field type option.'
  },
  mediaAndFiles: {
    id: 'field-type.add-field-menu.media-and-files',
    defaultMessage: 'Media & files',
    description: 'Short label for the media and files field type option in M2.'
  },
  link: {
    id: 'field-type.add-field-menu.link',
    defaultMessage: 'Link',
    description: 'Short label for the link field type option.'
  },
  description: {
    id: 'field-type.add-field-menu.description',
    defaultMessage: 'Description',
    description: 'Short label for description field type options.'
  }
});
